export const getUpdatedAuctions = (auctions = [], auction) => {
  return auctions?.find((i) => i?.auctionId === auction?.auctionId)
    ? auctions.map((item) => (
      item?.auctionId === auction?.auctionId
        ? ({
          ...item,
          lastOffer: auction?.lastOffer ? auction?.lastOffer : item?.lastOffer,
          topBid: auction?.topBid ? auction?.topBid : item?.topBid,
        })
        : (item)
    ))
    : [...auctions, auction]
}
// export const getUpdatedAuctions = (auctions = [], auction) => {
//   return auctions?.find((i) => i.auctionId)
//     ? (auctions?.map((item) => (
//       (item?.auctionId === auction?.auctionId)
//         ? ({
//           ...item,
//           ...auction,
//         })
//         : (item)))
//     ) : (
//       [...auctions, auction]
//     )
// }

export const getUpdatedAuctionsById = (auctions = [], auctionData) => {
  const indexAuction = auctions?.findIndex((a) => a.auctionId === auctionData?.auctionId)
  //
  if (indexAuction > -1) {
    auctions = auctions?.map((item) => {
      return (
        (item?.auctionId === auctionData?.auctionId)
          ? ({
            ...item,
            ...auctionData,
          })
          : (item))
    })
  } else {
    auctions = [...auctions || [], { ...auctionData, lastOffer: '' }]
  }
  return auctions
}

export const getLastOffer = (auctions, id) => {
  const auctionSelected = auctions?.find((auction) => auction.auctionId === id)
  return auctionSelected?.lastOffer
}

export const getTopBidById = (auctions, id) => {
  const auctionSelected = auctions?.find((auction) => auction.auctionId === id)
  return auctionSelected?.topBid
}
